import { GetServerSideProps } from "next";

const apiBaseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;
let sitemapBaseUrl: any = process.env.NEXT_PUBLIC_SITEMAP_BASE_URL;

// Ensure the base URL has a trailing slash
if (!sitemapBaseUrl.endsWith("/")) {
  sitemapBaseUrl += "/";
}

const generateSoftwareSolutionsSiteMap = (solutionUrls: string[]) => {
  return `<?xml version="1.0" encoding="UTF-8"?>
    <?xml-stylesheet type="text/xsl" href="${sitemapBaseUrl}main-sitemap.xsl"?>
    <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
        ${solutionUrls
          .map(
            (url: string) => `
                <url>
                    <loc>${url}</loc>
                    <changefreq>weekly</changefreq>
                    <priority>0.8</priority>
                </url>
                `
          )
          .join("")}
    </urlset>`;
};

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  try {
    const request = await fetch(`${apiBaseUrl}all-pages`);
    const slugs = await request.json();

    let solutionUrls: string[] = (slugs?.solutions || []).map(
      (slug: string) => `${sitemapBaseUrl}solutions/${slug}`
    );

    solutionUrls = Array.from(new Set(solutionUrls));

    const sitemap = generateSoftwareSolutionsSiteMap(solutionUrls);

    res.setHeader("Content-Type", "text/xml");
    res.write(sitemap);
    res.end();
  } catch (error) {
    console.error("Error generating Software Solutions sitemap:", error);
    res.statusCode = 500;
    res.end();
  }

  return { props: {} };
};

export default function SoftwareSolutionsSiteMap() {}
